<template>
	<!-- A component to display API error message -->
	<div
		class="alert alert-danger text-center font-weight-bold api-error"
		role="alert"
	>
		<i class="mdi mdi-cancel mr-2" />
		<div>
			<div>
				<b> {{ error }} </b>
			</div>
			<div>{{ detailError() }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		error: {
			type: Error,
			required: false,
			default: () => null
		}
	},
	methods: {
		detailError() {
			const { response } = this.error
			if (
				response &&
				response.data &&
				response.data.errors &&
				response.data.errors.length
			) {
				const { code, detail, id } = response.data.errors[0]
				return `${code} : ${detail} ( ID: ${id} )`
			}
			return null
		}
	}
}
</script>

<style scoped>
div.api-error {
	display: flex;
	align-items: center;
}
</style>
